import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { toggleAddFieldModal, toggleCreateFeedModal, toggleSelectPathModal } from '../../../slices/modals/reducer';
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Container, Row, Col, Card, CardHeader, CardBody,
  ListGroup, ListGroupItem, Button
} from "reactstrap";
import SelectField from './SelectField';
import Preview from './Preview';
import { createFeed, getFields } from '../../../slices/feeds/thunk';
import { addField, setFeedInfoOperations, setIsChangesMade } from '../../../slices/feeds/reducer';
import { useParams } from 'react-router-dom';

function AddFieldModal() {
  const dispatch = useDispatch();
  const params = useParams();

  // Select Feed Field Modal State
  const selectAddFieldModalState = createSelector((state) => state.Modal, (state) => ({
    addFieldModal: state.addFieldModal,
    feedModalType: state.feedModalType
  }));
  const { addFieldModal, feedModalType } = useSelector(selectAddFieldModalState);
  // Select Is Addıng New Feed State

  function goBack() {
    dispatch(toggleAddFieldModal());
  }

  function handleSubmit() {
    if (feedModalType === "feed") {
      dispatch(getFields());
      dispatch(createFeed(params));
      dispatch(toggleAddFieldModal());
    } else if (feedModalType === "field") {
      dispatch(addField());
      dispatch(setIsChangesMade(true));
      dispatch(toggleAddFieldModal());
    }
  }
  return (
    <Modal isOpen={addFieldModal} toggle={() => dispatch(toggleAddFieldModal())} centered size="xl">
      <ModalHeader className='p-3' toggle={() => dispatch(toggleAddFieldModal())}>
        {feedModalType === "feed" ? "Create New Feed"
          : feedModalType === "field" ? "Add New Field"
            : feedModalType === "operation" ? "Select Field to Add"
             : feedModalType === 'targetfield' ? 'Select Field to Add' : null}
      </ModalHeader>
      <ModalBody>
        <Row>
          <p className='text-body-secondary'>
            Great, your source is loaded! Now, pick the fields in the source you’re interested in. Titles, image links and prices are typical item fields that could  be of interest.
          </p>
        </Row>
        <Row>
          <Col>
            <Container className='bg-light' fluid>
              <Row>
                <Col md={feedModalType === "feed" ? 8 : 12} sm={12} xs={12}>
                  <SelectField />
                </Col>
                {feedModalType === "feed" ?
                  <Col md={4} sm={12} xs={12}>
                    <div className='w-100' style={{ padding: "16px 0px" }}>
                      <b className='btn btn-sm px-0 fs-13 fw-bold cursor-auto'>Preview</b>
                    </div>
                    <Preview />
                  </Col>
                  : null}
              </Row>
            </Container>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter className='border-top pt-3'>
        <Button color='light' onClick={goBack}>Back</Button>
        {feedModalType !== "operation" ?
          <Button color='success' onClick={handleSubmit}>
            {feedModalType === "feed" ? "Create Feed" : "Add Field"}
          </Button>
          : null}
      </ModalFooter>
    </Modal>
  )
}

export default AddFieldModal;